import React, { useRef } from 'react'
import CssBasline from '@mui/material/CssBaseline';
import { Switch, Route } from 'react-router-dom';
import Actor from '../components/Actor/Actor';
import useStyles from './Styles'
import useAlan from './Alan';
import { Movieinformation, NavBar, Profile, Movies } from './index';
const App = () => {
  const classes = useStyles();
  const alanBtnContainer = useRef();
  useAlan();
  return (
    <div className={classes.root}>
      <CssBasline />
      <NavBar />
      <main className={classes.content}>
        {/* <div className={classes.toolbar} /> */}
        <Switch>
          <Route exact path={["/", "/approved"]}>
            <Movies />
          </Route>
          <Route exact path='/movie/:id'>
        <Movieinformation />
          </Route>
          <Route exact path='/actor/:id'>
           <Actor />
          </Route>
          <Route exact path='/profile/:id'>
           <Profile />
          </Route>
          </Switch>
      </main>
      <div ref={alanBtnContainer} />
    </div>

  )
}

export default App